enum MissionTimeType {
  PERIOD = 'Period',
  SPECIFIC_DATE = 'SpecificDate',
  ANY_TIME = 'AnyTime',
}

export default MissionTimeType
